import { DashboardShell } from "./DashboardShell";
import { SettingsProvider } from "@/modules/settings";
import { NotificationProvider } from "@/modules/notifications";
import { SearchProvider } from "@/modules/search";
import { ToastProvider } from "@/shared/providers/ToastProvider";
import { MessagingProvider } from "@/modules/safecheck/messaging/MessagingProvider";

type AppPageLayoutProps = {
  children: React.ReactNode;
};

export function AppPageLayout({ children }: AppPageLayoutProps) {
  return (
    <ToastProvider>
      <NotificationProvider>
        <SearchProvider>
          <SettingsProvider>
            <MessagingProvider>
              <DashboardShell>{children}</DashboardShell>
            </MessagingProvider>
          </SettingsProvider>
        </SearchProvider>
      </NotificationProvider>
    </ToastProvider>
  );
}
